<template>
	<div class="ct-card-realisations">
		<div class="ct-card-realisations-image">
			<img :src="getImgUrl(getImageName(), realisation.directory || realisation.media.directory)">
		</div>
		<div class="ct-card-realisations-text">
			<div class="ct-card-realisations-text-title ct-policy-enter">
				{{ realisation.title }}
			</div>
			<div class="ct-card-realisations-text-content ct-justify-text">
				{{ realisation.typeText }} .{{ realisation.annee}}
			</div>
		</div>
		<router-link class="ct-card-realisations-footer ct-policy-enter" :to="'/realisations/' + realisation.id">
			<span class="ct-card-realisations-footer-item ct-clickable">Galerie</span>
		</router-link>
	</div>
</template>

<script>
	import {getDirectoryForDevice} from '../actions/generalData'

	export default {
		name: 'CtCardRealisations',
		props: {
			realisation: {
				type: Object,
				required: true,
			}
		},
		data() {
			return {
				deviceDirectory: '',
			}
		},
		methods: {
			getImgUrl(name, directory) {
				return require('../assets/' + this.deviceDirectory + directory + name)
			},
			getImageName() {
				return this.realisation.image || _.filter(this.realisation.media.images, "cover")[0].name;
			}
		},
		mounted: function() {
			this.deviceDirectory = getDirectoryForDevice(screen.width)
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.ct-card-realisations {
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.6);
		transition: 0.3s;
		border-radius: 3px;
		display: flex;
		flex-direction: column;
		background-color: white;
		height: 100%;
	}

	.ct-card-realisations:hover {
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
	}

	.ct-card-realisations-image {
		flex: 3;
	}

	.ct-card-realisations-image img {
		width: 100%;
	}

	.ct-card-realisations-text {
		padding: 1.5em;
		flex: 2;
	}

	.ct-card-realisations-text-title {
		display: flex;
		justify-content: flex-start;
		text-transform: uppercase;
		font-weight: 600;
	}

	.ct-card-realisations-footer {
		display: flex;
		justify-content: center;
		text-transform: uppercase;
		color: #B0E900;
		background-color: #4A4A4A;
		padding: 1.5em;
		flex: 1;
	}

	.ct-card-realisations-footer-item:hover {
		color: #CCFF33;
	}
</style>



// WEBPACK FOOTER //
// src/components/CtCardRealisations.vue